import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import Currencyhelper from '../../../../helpers/Currency';
import cls from './offerBoxPricing.module.scss';

function OfferBoxPricing({ eventHelper }) {
  const { t } = useTranslation();
  const locale = useSelector((state) => state.locale);

  if (eventHelper.getCaptainCount() === 0) {
    return (
      <div className={cls.block_price}>
        <div className={cls.all_price}>
          <div className={cls.empty_block_information}>
            {t('offerBox.emptyDesc')}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={cls.block_price}>
      <div className={cls.all_price}>
        <div className={cls.left_block}>
          <b>
            {Currencyhelper.getFormate(
              eventHelper.getBestPrice(),
              eventHelper.getCurrensy(),
              locale.current,
            )}
          </b>
          <span>
            {t('offerBox.dayRace')}: {eventHelper.getDaysLength()}
            <br />
            {t('offerBox.dayActive')}: {eventHelper.getActiveDaysLength()}
          </span>
        </div>
        {/* <div className={cls.right_block}>
              <span>
                {Currencyhelper.getFormate(
                  eventHelper.getBestPrice() * 2,
                  eventHelper.getCurrensy(),
                  locale.current,
                )}
              </span>
            </div> */}
      </div>
      <div className={cls.in_day_price}>
        <b>
          {eventHelper.getBestPriceAndVariable(
            eventHelper.getCurrensy(),
            locale.current,
          )}
        </b>
        <span>{t('offerBox.perActiveDay')}</span>
      </div>
    </div>
  );
}

OfferBoxPricing.propTypes = {
  eventHelper: PropTypes.shape().isRequired,
};

export default OfferBoxPricing;
